export enum FieldTypes {
	freeText = 'freeText',
	select = 'select',
	multiselect = 'multiselect',
	upload = 'upload',
	custom = 'custom',
	// reference: Feld zeigt auf ein anderes Label (Sub-Label / Labels-in-Labels).
	// Trägt referencedLabel (Ziel-Label-UUID) + cardinality (single|many).
	reference = 'reference'
}

// Kardinalität eines reference-Feldes.
export enum ReferenceCardinality {
	single = 'single',
	many = 'many'
}
